<template>
  <div class="field is-grouped is-grouped-centered">
    <v-col cols="12" sm="6">
      <v-text-field
        @input="setExpIngresada"
        v-model="experiencia"
        counter
        maxlength="50"
        :rules="[rules.required]"
        label="Nombre de la Experiencia:"
      ></v-text-field>
    </v-col>
  </div>
</template>

<script>
import {mapState} from "vuex";
export default {
  data: function () {
    return {
      name: "experiencia-comp",
      experiencia:"",
      rules: {
        required: (value) => !!value || "Obligatorio",
      },
    };
  },
  computed: {
    ...mapState(["experienciaStore"]),
  },
  methods:{
      setExpIngresada(){
      this.$store.commit("setExpe",this.experiencia)
    },
  }

};
</script>

<style lang="scss" scoped>
</style>